'use strict';

var _ = require('lodash');
var ChartLengthOfStayDataRetrieverService = function ChartLengthOfStayDataRetrieverService($q, momentService, pricingAnalysisCommonsDataService) {
  var MAX_DATA_LENGTH = 330;
  function createGap(lengthOfStay, stackLabel, gapLength) {
    return {
      lengthOfStay: lengthOfStay,
      m1: 0,
      m2: 0,
      m3: 0,
      stackLabel: stackLabel,
      gapLength: gapLength,
      tiles: [],
      isGap: true
    };
  }
  function addGaps(data) {
    for (var x = 0; x < data.length; x++) {
      var barData = data[x];
      var prevData = data[x - 1];
      var nextData = data[x + 1];
      var prevLengthOfStay = 0;
      var gapLengthOfStay, gapLength, stackLabel;
      if (prevData) {
        prevLengthOfStay = prevData.lengthOfStay;
      }
      if (barData.lengthOfStay - prevLengthOfStay > 1) {
        gapLengthOfStay = prevLengthOfStay + 1 + '-' + (barData.lengthOfStay - 1);
        gapLength = barData.lengthOfStay - prevLengthOfStay - 1;
        stackLabel = gapLengthOfStay;
        if (gapLength < 11) {
          stackLabel = '';
        }
        data.splice(x, 0, createGap(gapLengthOfStay, stackLabel, gapLength - 1));
      }
      if (!nextData) {
        if (barData.lengthOfStay < MAX_DATA_LENGTH) {
          gapLengthOfStay = barData.lengthOfStay + 1 + '-330';
          gapLength = MAX_DATA_LENGTH - (barData.lengthOfStay + 1);
          stackLabel = gapLengthOfStay;
          if (gapLength < 11) {
            stackLabel = '';
          }
          data.push(createGap(gapLengthOfStay, stackLabel, gapLength - 1));
        }
      }
    }
  }
  function transform(lengthOfStayData) {
    var transformedData = {
      data: [],
      originalLengthOfStay: []
    };
    transformedData.data = _.chain(lengthOfStayData).groupBy('lengthOfStay').transform(function (chartData, groupedData) {
      var data = pricingAnalysisCommonsDataService.getLatestService(groupedData);
      var transformedData = {
        departureDate: data.departureDate,
        lengthOfStay: data.lengthOfStay,
        carryCount: data.carryCount,
        runNumber: data.runNumber,
        stackLabel: data.lengthOfStay,
        tiles: [],
        data: [],
        source: data.source,
        isGap: false,
        selected: true,
        isTOD: data.isTOD
      };
      var fareRecommendedSum = 0;
      var roundTripFareOriginalSum = 0;
      var lowestCompetitorFareSum = 0;
      var lowestCompetitorFareTODSum = 0;
      var servicesNb = groupedData.length;
      var compCarriersOutbound = [];
      var compCarriersInbound = [];
      var compCarriersOutboundTOD = [];
      var compCarriersInboundTOD = [];
      var compToLowest = [];
      var compToLowestTOD = [];
      _.forEach(groupedData, function (d) {
        fareRecommendedSum += d.fareRecommended;
        roundTripFareOriginalSum += d.roundTripFareOriginal;
        lowestCompetitorFareSum += d.lowestCompetitorFare;
        lowestCompetitorFareTODSum += d.lowestCompetitorFareTOD;
        compCarriersOutbound.push(d.compCarrierOutbound);
        compCarriersInbound.push(d.compCarrierInbound);
        compCarriersOutboundTOD.push(d.compCarrierOutboundTOD);
        compCarriersInboundTOD.push(d.compCarrierInboundTOD);
        compToLowestTOD.push({
          compCarrier: d.compCarrierOutboundTOD,
          flightNbrs: d.compCarrierFlightNbrsOutboundTOD,
          direction: 'Outbound',
          fare: d.compCarrierFareOutboundTOD
        });
        compToLowestTOD.push({
          compCarrier: d.compCarrierInboundTOD,
          flightNbrs: d.compCarrierFlightNbrsInboundTOD,
          direction: 'Inbound',
          fare: d.compCarrierFareInboundTOD
        });
        compToLowest.push({
          compCarrier: d.compCarrierOutbound,
          flightNbrs: d.compCarrierFlightNbrsOutbound,
          direction: 'Outbound',
          fare: d.compCarrierFareOutbound
        });
        compToLowest.push({
          compCarrier: d.compCarrierInbound,
          flightNbrs: d.compCarrierFlightNbrsInbound,
          direction: 'Inbound',
          fare: d.compCarrierFareInbound
        });
        transformedData.data.push({
          serviceId: d.serviceId,
          shoppingRecordId: d.shoppingRecordId,
          originalServiceId: d.originalServiceId,
          marketOrigin: d.marketOrigin,
          marketDestination: d.marketDestination,
          cabinCode: d.cabinCode,
          pos: d.pos,
          direction: d.direction,
          departureDate: d.departureDate,
          departureTime: d.departureTime,
          source: d.source,
          carrier: d.carrier,
          key: [d.serviceId, d.originalServiceId, d.carrier, d.marketOrigin, d.marketDestination, d.departureDate, d.pos, d.cabinCode, d.direction].join('-')
        });
      });
      transformedData.m1 = _.round(fareRecommendedSum / servicesNb, 2);
      transformedData.m2 = _.round(roundTripFareOriginalSum / servicesNb, 2);
      transformedData.m3 = _.round(lowestCompetitorFareSum / servicesNb, 2);
      transformedData.circles = [{
        value: transformedData.m3,
        css: 'm4-circle'
      }];
      transformedData.compToLowest = _.uniqBy(compToLowest, function (obj) {
        return obj.compCarrier + obj.flightNbrs + obj.direction;
      });
      transformedData.compCarriersOutbound = _.uniq(compCarriersOutbound);
      transformedData.compCarriersInbound = _.uniq(compCarriersInbound);
      pricingAnalysisCommonsDataService.prepareTOD(transformedData, lowestCompetitorFareTODSum, servicesNb, compCarriersOutboundTOD, compCarriersInboundTOD, compToLowestTOD);
      if (transformedData.m2 > transformedData.m1) {
        transformedData.tiles.push({
          m2: transformedData.m1
        });
      }
      chartData.push(transformedData);
    }, []).sortBy('lengthOfStay').value();
    addGaps(transformedData.data);
    transformedData.originalLengthOfStay = _.map(transformedData.data, function (data) {
      return data.lengthOfStay;
    });
    transformedData.originalCarryCount = _.map(transformedData.data, function (data) {
      return data.carryCount;
    });
    return transformedData;
  }
  function isLengthOfStay(service) {
    return !_.isNil(service.lengthOfStay);
  }
  function prepareData(data) {
    return _.chain(data).filter(isLengthOfStay).value();
  }
  function getData(service, snapshotDate) {
    return pricingAnalysisCommonsDataService.retrieveLengthOfStayData(service, false, snapshotDate).then(prepareData).then(pricingAnalysisCommonsDataService.filterServicesThatMatchLatestClass).then(transform);
  }
  return {
    getData: getData
  };
};
ChartLengthOfStayDataRetrieverService.$inject = ['$q', 'MomentService', 'PricingAnalysisCommonsDataService'];
module.exports = ChartLengthOfStayDataRetrieverService;